<template>
	<div id="userCenter">
		<Layout>
			<Header :style="{ position: 'fixed', width: '100%' }">
				<pageHeader :content="true"></pageHeader>
			</Header>
			<Content class="contentMain" :style="{minHeight: mainHigh+'px'}">
				<Row :gutter="16">
					<Col span="6">
					<div class="u_c_M_Left">
						<div class="u_c_M_LeftTop">
							<Avatar v-if="user.photo==undefined" icon="ios-person" size="100" />
							<Avatar v-else :src="uPhotoUrl+user.photo" size="100" />
							<h2>{{user.nickname}}</h2>
						</div>
						<ucNav :style="{height:mainHigh-240+'px'}"></ucNav>
					</div>
					</Col>
					<Col span="18">
					<router-view ></router-view>
					</Col>
				</Row>
			</Content>
			<Footer>
				<pageFoot></pageFoot>
			</Footer>
		</Layout>
	</div>
</template>
<script>
	import pageFoot from '../../components/pageFoot/footer.vue';
	import pageHeader from '../content/home/header.vue';
	import ucGrade from '../../components/user/uCenterGrade.vue';
	import ucNav from '../../components/user/uCenterNav.vue';
	import {
		getToken
	} from '../../libs/util.js';
	import {
		userDetails
	} from '../../request/api.js'
	export default {
		name: 'userCenter',
		components: {
			pageFoot,
			pageHeader,
			ucGrade,
			ucNav
		},
		data() {
			return {
				uPhotoUrl: $yykConfig.avatarUrl,
				mainHigh: 700,
				user: {},
				activeName: this.$router.path
			}
		},
		methods: {

		},
		mounted() {
			var h = document.documentElement.clientHeight || document.body.clientHeight;
			// this.mainHigh = h - 64 - 172;
			const u = this.$store.state.userDetails;
			this.user = u;
		},
		created() {
			// userDetails().then(res => {
			// 	const resdata = res.member;
			// 	if (resdata.integral == undefined) {
			// 		resdata.integral = 0
			// 	}
			// 	this.$store.commit('updateUserData', resdata)
			// })
		},
		watch: {
			$route: {
				handler: function(val, oldVal) {
					this.activeName = val.name;
					if (val.name == 'kDetails') {
						this.activeName = "knowledge"
					}
				}
			}
		}
	}
</script>

<style>
	.ivu-layout-header {
		background: #FFF;
		padding: 0;
		height: 64px;
		line-height: 64px;
		z-index: 99;
	}

	.ivu-menu-horizontal.ivu-menu-light:after {
		display: none;
	}

	.ivu-layout-footer {
		padding: 0;
	}

	.contentMain {
		width: 1200px;
		margin: 64px auto 0;
		padding: 20px 0;
	}

	.u_c_M_Left {
		/* background-color: #FFFFFF; */
		/* height: 200px; */
	}

	.u_c_M_LeftTop {
		padding-top: 40px;
		text-align: center;
		height: 200px;
		background-color: #FFFFFF;
	}

	.u_c_M_LeftTop h2 {
		line-height: 40px;
	}

	.uCPageTop {
		padding: 20px;
		background-color: #FFF;
	}

	.uCPageTopTitle span {
		font-size: 24px;
	}

	.uCListBox {
		overflow: auto;
		overflow-x:hidden
		/* width: calc(100% - 10px); */
	}

	.uCListBox::-webkit-scrollbar {
		width: 5px;
		height: 1px;
	}

	.uCListBox::-webkit-scrollbar-thumb {
		/*滚动条里面小方块*/
		border-radius: 10px;
		background: #acacac;
	}

	.uCListBox::-webkit-scrollbar-track {
		/*滚动条里面轨道*/
		border-radius: 10px;
		background: #ededed;
	}
</style>
